(function () {
  // ——— i18n orçamento ———
  function getI18nOrc() {
    const addEl    = document.getElementById('i18n-orc-add');
    const removeEl = document.getElementById('i18n-orc-remove');
    return {
      add:    (addEl?.textContent || 'Adicionar ao orçamento').trim(),
      remove: (removeEl?.textContent || 'Remover').trim(),
    };
  }

  function getI18nLoadMore() {
  const ctaEl     = document.getElementById('i18n-loadmore-cta');
  const loadingEl = document.getElementById('i18n-loadmore-loading');
  return {
    cta:     (ctaEl?.textContent || 'Ainda tens dúvidas? Fala connosco').trim(),
    loading: (loadingEl?.textContent || 'A carregar…').trim(),
  };
}


  // ——— Sincroniza texto dos botões de orçamento ———
  function syncCartButtons() {
    const { add, remove } = getI18nOrc();
    const pedidos = JSON.parse(localStorage.getItem(LS_KEY_PEDIDOS) || '[]');
    document
      .querySelectorAll('.produto-orcamento button[onclick*="handleOrcamentoClick"]')
      .forEach(btn => {
        const box = btn.closest('.produto-orcamento');
        if (!box) return;
        const id = box.dataset.productId;
        const ativo = pedidos.some(p => p.id === id);
        btn.textContent = ativo ? remove : add;
      });
  }

  // ——— Config mínima ———
  const GRID_SEL = '#product-grid, #ProductGridContainer #product-grid, #ProductGridContainer .grid';
  const BTN_SEL  = '#LoadMoreButton';
  const BATCH    = 20;
  const CTA_TEXT = 'Ainda tens duvidas? Fala Connosco';
  const WA_URL   = 'https://wa.me/351928276603';

  let buffer   = [];
  let nextPage = null;
  let noMore   = false;

  function getSectionId(rootEl) {
    const sectionEl = rootEl.closest('[id^="shopify-section"]');
    return sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
  }

  function buildPageUrl(page, sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url;
  }

  async function fetchText(url) {
    const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.text();
  }

  async function fetchOnePageItems(page, sectionId) {
    // tenta section render
    let html = await fetchText(buildPageUrl(page, sectionId));
    let doc  = new DOMParser().parseFromString(html, 'text/html');
    let grid = doc.querySelector('#product-grid');
    let items = grid ? grid.querySelectorAll(':scope > li') : null;

    if (!items || !items.length) {
      // fallback: página completa
      html  = await fetchText(buildPageUrl(page, null));
      doc   = new DOMParser().parseFromString(html, 'text/html');
      grid  = doc.querySelector('#product-grid');
      items = grid ? grid.querySelectorAll(':scope > li') : doc.querySelectorAll('li.grid__item');
    }
    return Array.from(items || []);
  }

  async function ensureBuffer(gridEl, sectionId, want) {
    if (noMore) return;
    while (buffer.length < want) {
      const items = await fetchOnePageItems(nextPage, sectionId);
      if (!items.length) { noMore = true; break; }
      buffer.push(...items);
      nextPage += 1;
    }
  }

function appendFromBuffer(gridEl, qty) {
  const take = buffer.splice(0, qty);
  take.forEach(li => gridEl.appendChild(li));

  // ⬇️ depois de inserir, faz:
  requestAnimationFrame(() => {
    syncCartButtons();
    if (window.wireGridMetas) {
      // chama para cada <li> novo (ou chama uma vez com o grid, mas por nó é mais certeiro)
      take.forEach(n => window.wireGridMetas(n));
    }
  });

  return take.length;
}


function finishAsWhatsApp(btn) {
  const { cta } = getI18nLoadMore();
  btn.dataset.finished = 'true';
  btn.disabled = false;
  btn.removeAttribute('aria-busy');
  btn.textContent = cta;
  if (btn.tagName.toLowerCase() !== 'a') {
    btn.onclick = () => window.open(WA_URL, '_blank', 'noopener');
  }
}


  function init(context = document) {
    const grid = context.querySelector(GRID_SEL);
    const btn  = context.querySelector(BTN_SEL);
    if (!grid || !btn) return;

    if (btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';

    // limpa estados herdados
    btn.disabled = false;
    btn.removeAttribute('aria-busy');

    const curPage   = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
    const sectionId = getSectionId(grid) || btn.dataset.sectionId || null;

    buffer   = [];
    nextPage = curPage + 1;
    noMore   = false;

    // --- NOVO: mostrar já WhatsApp se não há mais para carregar ---
    const totalPagesAttr = parseInt(btn.dataset.totalPages || '0', 10);
    const itemsNow       = grid.querySelectorAll(':scope > li').length;

    if (Number.isFinite(totalPagesAttr) && totalPagesAttr > 0) {
      // Se sabemos o total de páginas, e já estamos na última → WhatsApp
      if (curPage >= totalPagesAttr) {
        finishAsWhatsApp(btn);
      }
    } else {
      // Fallback: se há ≤ 20 itens na página → não há mais
      if (itemsNow <= BATCH) {
        finishAsWhatsApp(btn);
      }
    }

    btn.addEventListener('click', async (e) => {
      if (btn.dataset.finished !== 'true') e.preventDefault();
      if (btn.dataset.finished === 'true') return;

      const label = btn.textContent;
      if (btn.tagName.toLowerCase() !== 'a') btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      const { loading } = getI18nLoadMore();
btn.textContent = loading;

      try {
        if (buffer.length < 1 && !noMore) {
          await ensureBuffer(grid, sectionId, BATCH);
        }
        const appended = appendFromBuffer(grid, BATCH);

        if ((appended === 0 && noMore) || (buffer.length === 0 && noMore)) {
          finishAsWhatsApp(btn);
          return;
        }
      } catch (err) {
        console.error('[LoadMore] Erro:', err);
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (btn.dataset.finished !== 'true') btn.textContent = label;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', () => {
    const container = document.getElementById('ProductGridContainer') || document;
    init(container);
  });
})();